/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Irrigation_Pump_Confirm_Off_TitleInputs */

const vi_irrigation_pump_confirm_off_title = /** @type {(inputs: Irrigation_Pump_Confirm_Off_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tắt bơm ${i?.name}?`)
};

/**

* @param {Irrigation_Pump_Confirm_Off_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_pump_confirm_off_title = /** @type {((inputs: Irrigation_Pump_Confirm_Off_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Pump_Confirm_Off_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_pump_confirm_off_title(inputs)
});